import { Component, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { Product, ProductGroup, ShoppingCart, ProductCountModel } from 'src/app/classes';
import { DataService } from 'src/app/services/data.service';
import { BackEndService } from 'src/app/backend-service';
import { NestedTreeControl } from '@angular/cdk/tree';
import { WistaAMSTypes } from 'src/app/wista-ams-types';
import { MatTreeNestedDataSource } from '@angular/material/tree';

@Component({
  selector: 'app-shop-core',
  templateUrl: './shop-core.component.html',
  styleUrls: ['./shop-core.component.css']
})
export class ShopCoreComponent implements OnInit {

  products: Product[] = [];
  mostCommonProducts: Product[] = [];
  treeProducts: Product[] = [];
  _filter: string = "";
  set filter(value: string){
    this._filter = value;
  }
  get filter(): string {
    return this._filter;
  }

  productCartMap = {};

  _cart: ShoppingCart;
  @Input() set cart(cart: ShoppingCart){
    if(!cart) return;
    this._cart = cart;
    this.hasCart = true;
    if(!cart.products) this.cart.products = [];
    this.cartChange.emit(this._cart);
    if(this.addProductOnInputChange){
      this.cart.addProduct(this.addProductOnInputChange);
      this.productCartMap[this.addProductOnInputChange.productid.toString()] = this.cart.products.filter(x => x.productid == this.addProductOnInputChange.productid).length;
      this.addProductOnInputChange = undefined;
    }
  }
  get cart(): ShoppingCart {
    return this._cart;
  }

  @Output() cartChange: EventEmitter<any> = new EventEmitter();
  @Output() createShoppingCart: EventEmitter<any> = new EventEmitter();

  hasCart: boolean = false;
  treeStructureLoaded: boolean = false;
  isLoadingProductGroups: boolean = false;
  treeControl = new NestedTreeControl<ProductGroup>(node => node.children);
  dataSource = new MatTreeNestedDataSource<ProductGroup>();
  addProductOnInputChange: Product;

  constructor(
    private _dataService: DataService,
    private _backEndService: BackEndService
  ) {
    
  }

  addProduct(product: Product){
    if(!this.cart){
      this.createShoppingCart.emit();
      this.addProductOnInputChange = product;
    } else {
      this.cart.addProduct(product);
      this.productCartMap[product.productid.toString()] = this.cart.products.filter(x => x.productid == product.productid).length;
    }
  }
  /**
   * the method returns a string representation of the product with the passed identifier
   */
  displayProduct(id) {
    if (!id) return "";
    let index = this.products.findIndex(x => x.productid == id);
    if (index == -1) return "";
    return this.products[index].productnumber + " " + this.products[index].productservice;
  }
  /**
   * returns, whether the passed group has children
   * @param _ 
   * @param node 
   */
  hasChild = (_: number, node: ProductGroup) => {
    let value = (!!node.children && node.children.length > 0) == true;
    return value;
  }
  /**
   * the method checks whether the passed product is matching the current setted product filter
   * @param product 
   */
  matchesProductFilter(product: Product): boolean {
    var i;
    if (!product) return false;
    if (!this.filter || this.filter.length == 0) return true;
    let f = this.filter.toLocaleLowerCase().replace(" ", "");
    if (product.productnumber) {
      if(product.productservice){
        let s = product.productnumber.toLocaleLowerCase() + product.productservice.toLocaleLowerCase();
        i = s.indexOf(f);
        if(i > -1) return true;
        else return false;
      }
      i = product.productnumber.toLowerCase().indexOf(f);
      if (i > -1) return true;
    }
    if (product.productservice) {
      i = product.productservice.toLowerCase().indexOf(f);
      if (i > -1) return true;
    }
    return false;
  }

  ngOnInit(): void {
    this._backEndService.get("api/offer-item/products/mostcommon/12").subscribe((data: ProductCountModel[]) => {
      this.mostCommonProducts = data.map(x => x.product);
      this._dataService.addProducts(data.map(x => x.product));
      this.products = this._dataService.products;
    });
    this._dataService.productsSearchedAnchor.subscribe(() => {
      this.products = this._dataService.products;
    });
  }

  loadProductGroups(){
    this.isLoadingProductGroups = true;
    this._backEndService.get("api/productgroup").subscribe((productGroups: ProductGroup[]) => {
      for(let product of productGroups){
        if(product.productgroupparent){
          let parent = productGroups.find(x => x.productgroupid == product.productgroupparent);
          if(parent){
            if(!Array.isArray(parent.children)) parent.children = [];
            parent.children.push(product);
          }
        }
      }
      this.dataSource.data = productGroups.filter(x => x.productgroupparent == null);
      this.isLoadingProductGroups = false;
      this.treeStructureLoaded = true;
      console.log(this.dataSource.data);
    });
  }

  searchProduct(){
    this._dataService.searchProduct(this.filter);
  }

  tabChanged(index: number){
    if(index == 1 && !this.treeStructureLoaded && !this.isLoadingProductGroups) this.loadProductGroups();
  }

  treeGroupSelected(group: ProductGroup){
    if(!group.children || group.children.length == 0){
      this._dataService.resolve(WistaAMSTypes.ProductInGroup, group.productgroupid, (products: Product[]) => {
        this._dataService.addProducts(products);
        this.treeProducts = products;
        this.products = this._dataService.products;
      });
    }
  }

}
